module.exports = __webpack_public_path__ + "static/ic_draw_wait.b1ab2373.png";